import { type ChangeEvent } from 'react'

import { TextArea } from '@/shared'

interface IProps {
    value: string
    className: string
    isEdit: boolean
    onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
}

export const EditableSpan = (props: IProps) => {
    const { className, value, isEdit, onChange } = props
    return (
        <>
            {isEdit && <TextArea value={value} onChange={onChange} className={className} />}
            {!isEdit && <TextArea value={value} onChange={onChange} disabled className={className} />}
        </>
    )
}
